import React from 'react';
import { Container } from 'reactstrap';
import CrudList from './list';

const SubstanciaUso = () => (
  <div className="containerInside__wrap">
    <Container>
      <CrudList />
    </Container>
  </div>
);

export default SubstanciaUso;